import React, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './DndContainer.module.less';

import { Card, Space } from 'antd';
import { HolderOutlined, CloseOutlined } from '@ant-design/icons';
import { styled } from '@stitches/configed';

const ActionStyled = styled('div', {
  '&:hover': {
    backgroundColor: '#F5F7FF',
  },
});
export interface DndContainerProps {
  children: React.ReactNode;
  columns?: number;
  title?: string;
  style?: React.CSSProperties;
  horizontal?: boolean;
  hover?: boolean;
  handleProps?: React.HTMLAttributes<any>;
  scrollable?: boolean;
  shadow?: boolean;
  placeholder?: boolean;
  unstyled?: boolean;
  noCard?: boolean;
  onRemove?(): void;
}

export const DndContainer = forwardRef<
  HTMLDivElement & HTMLButtonElement,
  DndContainerProps
>(
  (
    {
      children,
      columns = 1,
      handleProps,
      horizontal,
      hover,
      onRemove,
      title,
      placeholder,
      style,
      scrollable,
      shadow,
      unstyled,
      noCard,
      ...props
    }: DndContainerProps,
    ref,
  ) => {
    return (
      <div
        {...props}
        ref={ref}
        style={
          {
            ...style,
            '--columns': columns,
          } as React.CSSProperties
        }
        className={classNames(
          styles.DndContainer,
          unstyled && styles.unstyled,
          horizontal && styles.horizontal,
          hover && styles.hover,
          placeholder && styles.placeholder,
          scrollable && styles.scrollable,
          shadow && styles.shadow,
        )}
      >
        {noCard ? (
          <div>{placeholder ? children : <ul>{children}</ul>}</div>
        ) : (
          <Card
            title={title}
            extra={
              (onRemove || handleProps) && (
                <Space>
                  {onRemove && <CloseOutlined onClick={onRemove} />}
                  {handleProps && (
                    <ActionStyled
                      {...handleProps}
                      style={{ cursor: 'grabbing', fontSize: 20 }}
                    >
                      <HolderOutlined />
                    </ActionStyled>
                  )}
                </Space>
              )
            }
          >
            {placeholder ? children : <ul>{children}</ul>}
          </Card>
        )}
      </div>
    );
  },
);
